// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/DriveNotification.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";

export const protobufPackage = "daisi.protos.v1";

export interface HostOfflineNotification {
  HostId: string;
  AccountId: string;
}

export interface HostOnlineNotification {
  HostId: string;
  AccountId: string;
}

export interface HostOfflineAck {
  Received: boolean;
}

export interface HostOnlineAck {
  Received: boolean;
}

function createBaseHostOfflineNotification(): HostOfflineNotification {
  return { HostId: "", AccountId: "" };
}

export const HostOfflineNotification: MessageFns<HostOfflineNotification> = {
  encode(message: HostOfflineNotification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostOfflineNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostOfflineNotification();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostOfflineNotification {
    return {
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
    };
  },

  toJSON(message: HostOfflineNotification): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostOfflineNotification>, I>>(base?: I): HostOfflineNotification {
    return HostOfflineNotification.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostOfflineNotification>, I>>(object: I): HostOfflineNotification {
    const message = createBaseHostOfflineNotification();
    message.HostId = object.HostId ?? "";
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseHostOnlineNotification(): HostOnlineNotification {
  return { HostId: "", AccountId: "" };
}

export const HostOnlineNotification: MessageFns<HostOnlineNotification> = {
  encode(message: HostOnlineNotification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostOnlineNotification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostOnlineNotification();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostOnlineNotification {
    return {
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
    };
  },

  toJSON(message: HostOnlineNotification): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostOnlineNotification>, I>>(base?: I): HostOnlineNotification {
    return HostOnlineNotification.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostOnlineNotification>, I>>(object: I): HostOnlineNotification {
    const message = createBaseHostOnlineNotification();
    message.HostId = object.HostId ?? "";
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseHostOfflineAck(): HostOfflineAck {
  return { Received: false };
}

export const HostOfflineAck: MessageFns<HostOfflineAck> = {
  encode(message: HostOfflineAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Received !== false) {
      writer.uint32(8).bool(message.Received);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostOfflineAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostOfflineAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Received = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostOfflineAck {
    return { Received: isSet(object.Received) ? globalThis.Boolean(object.Received) : false };
  },

  toJSON(message: HostOfflineAck): unknown {
    const obj: any = {};
    if (message.Received !== false) {
      obj.Received = message.Received;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostOfflineAck>, I>>(base?: I): HostOfflineAck {
    return HostOfflineAck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostOfflineAck>, I>>(object: I): HostOfflineAck {
    const message = createBaseHostOfflineAck();
    message.Received = object.Received ?? false;
    return message;
  },
};

function createBaseHostOnlineAck(): HostOnlineAck {
  return { Received: false };
}

export const HostOnlineAck: MessageFns<HostOnlineAck> = {
  encode(message: HostOnlineAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Received !== false) {
      writer.uint32(8).bool(message.Received);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostOnlineAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostOnlineAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Received = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostOnlineAck {
    return { Received: isSet(object.Received) ? globalThis.Boolean(object.Received) : false };
  },

  toJSON(message: HostOnlineAck): unknown {
    const obj: any = {};
    if (message.Received !== false) {
      obj.Received = message.Received;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostOnlineAck>, I>>(base?: I): HostOnlineAck {
    return HostOnlineAck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostOnlineAck>, I>>(object: I): HostOnlineAck {
    const message = createBaseHostOnlineAck();
    message.Received = object.Received ?? false;
    return message;
  },
};

export type DriveNotificationProtoDefinition = typeof DriveNotificationProtoDefinition;
export const DriveNotificationProtoDefinition = {
  name: "DriveNotificationProto",
  fullName: "daisi.protos.v1.DriveNotificationProto",
  methods: {
    hostWentOffline: {
      name: "HostWentOffline",
      requestType: HostOfflineNotification,
      requestStream: false,
      responseType: HostOfflineAck,
      responseStream: false,
      options: {},
    },
    hostCameOnline: {
      name: "HostCameOnline",
      requestType: HostOnlineNotification,
      requestStream: false,
      responseType: HostOnlineAck,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface DriveNotificationProtoServiceImplementation<CallContextExt = {}> {
  hostWentOffline(
    request: HostOfflineNotification,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<HostOfflineAck>>;
  hostCameOnline(
    request: HostOnlineNotification,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<HostOnlineAck>>;
}

export interface DriveNotificationProtoClient<CallOptionsExt = {}> {
  hostWentOffline(
    request: DeepPartial<HostOfflineNotification>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<HostOfflineAck>;
  hostCameOnline(
    request: DeepPartial<HostOnlineNotification>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<HostOnlineAck>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
